import type { AppRouteRecordRaw } from '/@/router/types';
import {
  LAYOUT,
  PAGE_NOT_FOUND_NAME,
} from '/@/router/constant';

// 404 on a page
export const PAGE_NOT_FOUND_ROUTE: AppRouteRecordRaw = {
  path: '/:path(.*)*',
  name: PAGE_NOT_FOUND_NAME,
  component: LAYOUT,
  meta: {
    title: '页面错误',
    hideBreadcrumb: true,
    hideMenu: true,
  },
  children: [
    {
      path: '/:path(.*)*',
      name: PAGE_NOT_FOUND_NAME,
      component: () => import('/@/views/404/index.vue'),
      meta: {
        title: '页面错误',
        hideBreadcrumb: true,
        hideMenu: true,
      },
    },
  ],
};
